import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, filter, map, mergeMap, of, withLatestFrom } from 'rxjs';
import { NOTIFICATION_SHOW, SERVICE_FAILURE, NOTIFICATION_SUBSCRIBE } from '@store/actions';
import { Store } from '@ngrx/store';
import { selectStore } from '@store/selectors';
import { NotificationService } from '@core/services'
import { NotificationEnum } from '@shared/components/notification/enum/notification.enum';

@Injectable()
export class NotificationEffects {
  constructor(
    private actions$: Actions,
    private store: Store,
    private notificationService: NotificationService
  ) {}

  serviceFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SERVICE_FAILURE),
        mergeMap(({ notification })  => {

            return of(NOTIFICATION_SHOW({ notification }));
        })
      ),
  );

  create$ = createEffect(() =>
    this.actions$.pipe(
      ofType(NOTIFICATION_SUBSCRIBE),
      mergeMap(({ token }) => {

        return this.notificationService.subcribeNotification(token).pipe(
          mergeMap(() => {
            return [
            ];
          }),
          catchError((error) => of(NOTIFICATION_SHOW({notification:{
            title: NotificationEnum.Failure,
            type: NotificationEnum.Error,
            detail: NotificationEnum.SubcribeNotificationFailure,
          }})))
        );
      })
    )
  );

}
